/** List of known extension keys on the checklist item */ export var ChecklistItemExtensionKeys = /*#__PURE__*/ function(ChecklistItemExtensionKeys) {
    /** Service understood legacy data from basic plans */ ChecklistItemExtensionKeys["legacyData"] = "LegacyData";
    return ChecklistItemExtensionKeys;
}({});
